import { useContext } from 'react';

import { ChatContext, type ChatContextValue } from './chatContext';

/** In its own file so AiChatProvider.tsx exports only components — otherwise React… */
export function useAiChat(): ChatContextValue {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error('useAiChat must be used inside <AiChatProvider>');
  return ctx;
}
